import React from 'react'
import SignUpPage from '../../pages/signup/signup.page'

const SignUpLayout = () => {
  return (
    <SignUpPage/>
  )
}

export default SignUpLayout